var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"name":"check-button","size":"lg","switch":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }